import React from 'react';
import styled from "styled-components";
import {FlexWrapper} from "../../../components/FlexWrapper";
import {Container} from "../../../components/Container";
import contactsIcon from "./../../../assets/images/galanovAlex.png"
import {theme} from "../../../styles/Theme";
import {MenuContacts} from "./menuContacts/MenuContacts";

export const Contacts = () => {
    return (
        <StyledContacts id={"Contacts"}>
            <Container>

                <ContactsWrapper>
                    <FlexWrapper direction="column">
                      <Logo src={contactsIcon}/>
                        <TextContactsLeft>Looking for a developer? Let's discuss your project and bring your ideas to life with modern web technologies.</TextContactsLeft>
                    </FlexWrapper>
                    <FlexWrapper align="start">
                        <MenuContacts/>
                    </FlexWrapper>
                    <FlexWrapper direction="column" align="start">
                        <TextContactsRight>Just feel free to contact if you wanna collaborate with me, or simply
                            have a
                            conversation.</TextContactsRight>
                        <Email href="mailto:a.halanau@gmail.com">a.halanau@gmail.com</Email>
                    </FlexWrapper>
                </ContactsWrapper>
            </Container>
        </StyledContacts>
    );
};

const StyledContacts = styled.section`
    nav {
        ul {
            flex-direction: column;
        }
    }
`

const TextContactsLeft = styled.p`
    font-size: 18px;
    font-weight: 400;
    line-height: 225.02%;
    max-width: 300px;
`

const TextContactsRight = styled.p`
    font-size: 18px;
    font-weight: 400;
    line-height: 225.02%;
    max-width: 340px;
`

const Email = styled.a`
    font-size: 30px;
    font-weight: 300;
    line-height: 183.02%;
    text-decoration: underline;
    cursor: pointer;
    color: ${theme.colors.secondaryBg};
    text-decoration-color: ${theme.colors.secondaryBg};

    &:visited {
        color: ${theme.colors.secondaryBg};
    }

    &:hover {
        transform: scale(110%);
        transition: transform 0.7s;
    }
`

const Logo = styled.img`
    width: 100px;
    height: 70px;

    @media screen and (max-width: 1140px) {
        display: block;
        justify-content: center;
        align-items: center;

    }
`

const ContactsWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 850px) {
        flex-wrap: wrap;
        justify-content: center;
        gap:50px;
    }
`